import type { ServiceCardItem } from "@/types";

export const servicesList: ServiceCardItem[] = [
  {
    title: "Residential Solar",
    description:
      "Transform your home with a customised solar power system designed to maximise savings and energy independence.",
    image: "/images/products/residential.webp",
    link: "/services/residential-solar",
  },
  {
    title: "Commercial Solar",
    description:
      "Scalable solar solutions for businesses of all sizes. Reduce operational costs and boost your green credentials.",
    image: "/images/products/commercial.webp",
    link: "/services/commercial-solar",
  },
  {
    title: "Battery Storage",
    description:
      "Store excess solar energy and power your home day and night with premium battery storage systems.",
    image: "/images/products/battery.webp",
    link: "/services/battery-storage",
  },
  {
    title: "EV Charger",
    description:
      "Future-proof your property with smart EV charging solutions integrated with your solar system.",
    image: "/images/products/ev-charger.webp",
    link: "/services/ev-charger",
  },
  {
    title: "Battery Materials",
    description:
      "We source only the highest quality battery cells and materials from trusted global manufacturers.",
    image: "/images/products/battery.webp",
    link: "/services/battery-storage",
  },
  {
    title: "Charge Controllers",
    description:
      "Advanced MPPT and PWM charge controllers to optimise your solar system performance and battery life.",
    image: "/images/products/commercial.webp",
    link: "/services/residential-solar",
  },
];
